import React, { useEffect, useState, useRef } from 'react';
import { useStateValue } from '../../../services/ContextProvider';
import { userActionTypes } from '../../../services/Reducers/userReducer';
import { getAdmins, getAllUsers, getFilteredUsers } from '../../../services/userService';
import AdminPanelUserTile from './AdminPanelUserTile';
import APUserTileSkeleton from './APUserTileSkeleton';
import './ManageUsersComponent.scss';

const APUserSearchField = ({ onChangeFn, adminSelectFn, adminSelect }) => {
  return (
    <div className="APUserSearchField">
      <div className="AP-user-name-search-section">
        <form id='ap-user-search-field'>
          <input
            type="text"
            className='AP-user-search-field'
            placeholder='Type a name for search...'
            disabled={adminSelect}
            onChange={(e) => onChangeFn(e.target.value)} />
        </form>
      </div>
      <div className="AP-user-select-admin-section">
        <input
          type="checkbox"
          onChange={(e) => { adminSelectFn(e.target.checked); }} />
        <label className="AP-show-admins-lable" >Show Admins</label>
      </div>
    </div>
  );
};

const ManageUsersComponent = () => {

  const { userState, userDispatch } = useStateValue();
  const [usersLength, setUsersLength] = useState(userState.userList.length);
  const paginateMarginRef = useRef(null);
  const listContainerRef = useRef(null);
  const [isAdminSelected, setIsAdminSelected] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [allFetched, setAllFetched] = useState(false);
  const [searchKey, setSearchKey] = useState(null);

  useEffect(async () => {
    await handleScroll();
  }, []);

  const handleKeywordChange = async (value) => {
    userDispatch({
      type: userActionTypes.SET_USER_LIST,
      userList: []
    });
    if (value === '') setAllFetched(false);
    else setAllFetched(true);
    setSearchKey(value);
  };

  const handleCheckBoxChange = (value) => {
    userDispatch({
      type: userActionTypes.SET_USER_LIST,
      userList: []
    });
    if (value === false) setAllFetched(false);
    else {
      setAllFetched(true);
      document.getElementById('ap-user-search-field').reset();
      setSearchKey(null);
    }
    setIsAdminSelected(value);
  };

  useEffect(async () => {
    if (searchKey !== null && searchKey !== '') {
      await getFilteredUsers(searchKey, userDispatch);
    } else if (searchKey === '') {
      await handleScroll();
    }
  }, [searchKey]);

  useEffect(async () => {
    if (isAdminSelected === true) {
      await getAdmins(userDispatch);
    } else if (isAdminSelected !== null) {
      await handleScroll();
    }
  }, [isAdminSelected]);

  const checkScrollHeight = (containerRef, marginRef) => {
    let containerY = containerRef.current.getBoundingClientRect().y;
    let containerHeight = containerRef.current.getBoundingClientRect().height;
    let marginY = marginRef.current.getBoundingClientRect().y;
    return containerY + containerHeight >= marginY;
  };

  const handleScroll = async () => {
    if (listContainerRef !== null && paginateMarginRef !== null) {
      console.log(allFetched, dataLoading);
      if (!allFetched && !dataLoading && checkScrollHeight(listContainerRef, paginateMarginRef)) {
        setDataLoading(true);
        await getAllUsers(userState.userList, userDispatch, searchKey, isAdminSelected);
        setDataLoading(value => !value);
      }
    }
  };

  useEffect(async () => {
    if (!dataLoading && userState.userList.length !== 0) {
      console.log(userState.userList.length, usersLength);
      if (userState.userList.length === usersLength) {
        console.log('all fetched');
        setAllFetched(true);
      } else {
        setUsersLength(userState.userList.length);
        await handleScroll();
        // console.log(userState.userList.length, usersLength);
      }
    }
  }, [dataLoading]);

  useEffect(() => {
    //console.log(allFetched, dataLoading);
  }, [allFetched]);

  return (
    <div className="ManageUsersComponent">
      {
        <APUserSearchField onChangeFn={handleKeywordChange} adminSelectFn={handleCheckBoxChange} adminSelect={isAdminSelected} />
      }
      <div ref={listContainerRef} className="manage-user-scroll-container" onScroll={handleScroll}>
        <div className="user-tile-grid">
          {
            userState.userList.map(user => (<AdminPanelUserTile key={user.uid} user={user} />))
          }
        </div>
        <div ref={paginateMarginRef} className="ap-user-list-paginate-limit"></div>
        {dataLoading && !allFetched &&
          <div className="user-tile-grid">
            <APUserTileSkeleton />
          </div>
        }
      </div>
    </div>
  );
};

export default ManageUsersComponent;
